import { motion } from "framer-motion";
import styled from "styled-components";
import { v, b } from "../styles/variables";

export const Section = styled(motion.section)`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	row-gap: ${v.mediumDist};
	width: 100%;
	max-width: 1920px;
	min-height: calc(100vh - ${v.headerHeight} - ${v.xxLargeDist} * 2);

	@media ${b.medium} {
		flex-direction: row;
		column-gap: ${v.mediumDist};
	}
`;

export const Title = styled(motion.div)`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: ${v.mediumDist};

	svg {
		width: 60px;
		color: ${({ theme }) => theme.primary};
	}
`;

export const Notes = styled(motion.div)`
	background: ${({ theme }) => theme.bg};
	box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
	border-radius: 5px;
	padding: ${v.mediumDist};

	.btn-container {
		margin-top: ${v.largeDist};
		text-align: right;
	}

	h3 {
		text-transform: uppercase;
	}

	.note {
		margin-top: ${v.smallDist};
		text-align: justify;

		@media ${b.medium} {
			text-align: left;
		}

		span {
			color: ${({ theme }) => theme.primary};
			font-weight: bold;
		}
	}
`;
